import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  TextField,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import {
  cardOutline,
  fonts,
  semiBoldFonts,
  textFieldStyles,
} from "../../../Styles/Styles";

export default function LocationFilter({ onFilterChange, defaultLocation }) {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(
    defaultLocation || ""
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLocations = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/locations/`
        );
        if (!response.ok) throw new Error("Failed to fetch locations");
        const data = await response.json();
        setLocations(data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, []);

  useEffect(() => {
    setSelectedLocation(defaultLocation || ""); // Sync with URL
  }, [defaultLocation]);

  const handleLocationChange = (_, newValue) => {
    const locationName = newValue ? newValue.name : "";
    setSelectedLocation(locationName);
    onFilterChange({ location: locationName }); // Update filters
  };

  return (
    <Box
      sx={{
        p: 2,
        mb: 2,
        borderRadius: "8px",
        ...cardOutline,
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ mb: 2, ...semiBoldFonts }}>
        Location
      </Typography>
      <Autocomplete
        options={locations}
        getOptionLabel={(option) => option.name}
        value={locations.find((loc) => loc.name === selectedLocation) || null}
        onChange={handleLocationChange}
        loading={loading}
        isOptionEqualToValue={(option, value) => option.name === value?.name}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Location"
            variant="outlined"
            fullWidth
            error={!!error}
            helperText={error || ""}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            sx={{ ...textFieldStyles }}
          />
        )}
        slotProps={{
          popper: {
            sx: {
              "& .MuiAutocomplete-listbox": {
                ...fonts,
              },
            },
          },
        }}
      />
    </Box>
  );
}
